import { render } from "./register.vue?vue&type=template&id=78fdf315&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=78fdf315&lang=scss&scoped=true"
import "./register.vue?vue&type=style&index=1&id=78fdf315&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fdf315"]])

export default __exports__